module.exports = __webpack_public_path__ + "static/media/water_bag.4666cd36.png";